import React from 'react';

import { useResto } from '../../contexts/RestoContext';

const TopAlert = () => {
  const { restoData } = useResto();

  if (!restoData.alert) {
    return;
  }

  return (
    <div id="alert-block" className="alert-message">
        {restoData.alert}
    </div>
)};

export default TopAlert;
